import { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Formik, Form } from 'formik';
import { Container, Typography, Stack, Box, Button, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { axiosPrivate } from '../../../common/axiosPrivate';
import NotificationContext from '../../../context/notificationContext';
import AuthContext from '../../../context/authContext';

import FotoForm from '../../../sections/@dashboard/pegawai/forms/FotoForm';
import pegawaiFormModel from '../../../sections/@dashboard/pegawai/form-model/pegawaiFormModel';
import validationSchema from '../../../sections/@dashboard/pegawai/form-model/validationSchema';

const FotoPegawaiPage = ({id, handleCloseModal, handleUpdateTable}) => {
  const notificationCtx = useContext(NotificationContext);
  const { user } = useContext(AuthContext);
  const [pageLoading, setPageLoading] = useState(true);
  const { formId, formField } = pegawaiFormModel;
  const [initialValues, setInitialValues] = useState({});

  const handleSubmit = async (values, actions) => {
    const kodePegawai = values?.kode;
    const params = {
      profilUrl: values.profilUrl,
      ttdUrl: values.ttdUrl
    };

    // console.log(JSON.stringify({id, kodePegawai, newData: params}));

    await axiosPrivate.post(`/pegawai/file/${id}`, {
      id,
      kodePegawai,
      dibuatOleh: user?._id,
      tglUbah: moment().format('YYYY-MM-DDTHH:mm:ss'),
      newData: params
    })
    .then((response) => {
      // console.log(response)
      const { result } = response?.data;

      handleUpdateTable(result);
      handleMessage(response?.data);
    })
    .catch((error) => {
      console.log(error);
      handleMessage(error)
    })
    .finally(() => {
      actions.setSubmitting(false);
    });
  }

  const handleMessage = (params) => {
    if(params?.success) {
      notificationCtx.setup({
        severity: 'success',
        title: 'Success',
        message: 'Data Berhasil Diubah.'
      });
    } else {
      notificationCtx.setup({
        severity: 'error',
        title: 'Error',
        message: params?.response
      })
    }
  }

  useEffect(() => {
    axiosPrivate.get(`/pegawai/${id}`)
    .then((response) => {
      const data = response?.data;

      setInitialValues({
        kode: data.kodePegawai,
        profilUrl: data.profilUrlId ? `https://drive.google.com/thumbnail?id=${data.profilUrlId}` : '',
        ttdUrl: data.ttdUrlId ? `https://drive.google.com/thumbnail?id=${data.ttdUrlId}` : ''
      });
    })
    .catch((error) => console.log(error?.response))
    .finally(() => setPageLoading(false));
  }, [id]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Ubah Foto
            </Typography>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema[3]}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form id={formId}>
                <FotoForm
                  idPegawai={id}
                  formField={formField}
                />
                <Stack
                  direction="row"
                  justifyContent="end"
                  mt={2}
                  spacing={1}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseModal}
                  >
                    Kembali
                  </Button>
                  <LoadingButton
                    type="submit"
                    loading={isSubmitting}
                    variant="contained"
                  >
                    Simpan
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
        </Container>
        )}
    </>
  );
};
  
export default FotoPegawaiPage;
